import { createCmgSimulatorAssmat } from '../calculators/cmg_simulator_assmat';

window.cmg_simulator = undefined;
document.addEventListener('turbo:load', function() {
  const assmatCmgSimulatorElement = document.getElementById('paje-simulator');

  if (assmatCmgSimulatorElement) {
    window.cmg_simulator = createCmgSimulatorAssmat();

    $('body').on('click', '.cmg-maxerror', function() {
      const element = document.getElementById('global-result');
      element.scrollIntoView();
    });
  }
});
